(function(){
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('details.mega-menu').forEach(function(details){
      var timeout;

      details.addEventListener('mouseenter', function(){
        clearTimeout(timeout);
        details.setAttribute('open', '');
      });

      details.addEventListener('mouseleave', function(){
        timeout = setTimeout(function(){
          details.removeAttribute('open');
        }, 150);
      });

      // Wenn Maus ins Dropdown kommt, timeout abbrechen
      var content = details.querySelector('.mega-menu__content');
      if (content) {
        content.addEventListener('mouseenter', function(){
          clearTimeout(timeout);
        });
        content.addEventListener('mouseleave', function(){
          timeout = setTimeout(function(){
            details.removeAttribute('open');
          }, 150);
        });
      }
    });
  });
})();